/**
 * Stack routes of the native screens added by the `extras2` admin-module group.
 * The resources import wires the extras2 list resources into the shared marketing registry at app start.
 */
import lazyScreen from '../../components/lazyScreen';
import '../../screens/adminModules/extras2/extras2Resources';

const ROUTES = [
    {name: 'Extras2ResourceScreen', component: lazyScreen(() => import('../../screens/adminModules/extras2/Extras2ResourceScreen'))},
    {name: 'Extras2DetailScreen', component: lazyScreen(() => import('../../screens/adminModules/extras2/Extras2DetailScreen'))},
    {name: 'Extras2FormScreen', component: lazyScreen(() => import('../../screens/adminModules/extras2/Extras2FormScreen'))},
    {name: 'Extras2SegmentBuilderScreen', component: lazyScreen(() => import('../../screens/adminModules/extras2/SegmentBuilderScreen'))},
    {name: 'Extras2TemplateEditorScreen', component: lazyScreen(() => import('../../screens/adminModules/extras2/TemplateEditorScreen'))},
    {name: 'Extras2SurveyEditorScreen', component: lazyScreen(() => import('../../screens/adminModules/extras2/SurveyEditorScreen'))},
    {name: 'Extras2SurveyResultsScreen', component: lazyScreen(() => import('../../screens/adminModules/extras2/SurveyResultsScreen'))},
];

export default ROUTES;
